import React from 'react';
import moment from 'moment';
import { Button, Modal } from 'react-bootstrap';

import { highlightCards } from '../../util/insightsUtils';

import Close from '../../assets/img/close.svg';
import AdminIcon from './images/admin-icon.svg';
import ContextIcon from './images/context.svg';
import FindingsIcon from './images/findings.svg';
import ImpactIcon from './images/impact.svg';
import InvestigationTrail from './images/investigation-trail.svg';
import Evidence from './images/evidence.svg';

import './InsightWhyModal.scss';

function InsightWhyModal({ show, onHide, data, summary = false, dateFormat = 'DD MMM YYYY HH:mm:ss' }) {
  if (!data) return null;

  const { context, analysis, narrative, metadata } = data;
  const investigation = summary ? data.reasoning : data.reasoning;
  const evidence = summary ? data.evidence : analysis?.evidence;
  const findings = analysis?.finding;
  const impactData = analysis?.impact;
  const insightEvidence = data.evidence

  return (
    <Modal show={show} onHide={onHide} centered className="insight-modal">
      <Modal.Header>
        <Modal.Title>Why this insight?</Modal.Title>
        <Button variant="close" onClick={onHide}>
          <img src={Close} alt="close" />
        </Button>
      </Modal.Header>
      <Modal.Body>
        {data.adminInfo && (
          <div className="admin-info">
            <h4 className="insight-card-title"><img src={AdminIcon} alt="Admin"/>Admin Info</h4>
            <ul className="insight-card__list--bullet">
              <li>
                <span>Dashboard:</span>
                <strong>{data.adminInfo.dashboard}</strong>
              </li>
              <li>
                <span>Duration:</span>
                <strong>{data.adminInfo.duration}</strong>
              </li>
              <li>
                <span>Cost:</span>
                <strong>{data.adminInfo.cost} $</strong>
              </li>
              <li>
                <span>Date:</span>
                <strong>{moment(data.adminInfo.date).format(dateFormat)}</strong>
              </li>
              <li>
                <span>Model:</span>
                <strong>{data.adminInfo.model}</strong>
              </li>
            </ul>
          </div>
        )}

        <div className="insight-box">
          {context && (
            <div className="insight-card__detail">
              <h4 className="insight-card-title">
                <img src={ContextIcon} alt="Context" /> CONTEXT
              </h4>
              <p className="insight-card__detail-description">{context}</p>
            </div>
          )}

          {findings && (
            <div className="insight-card__detail">
              <h4 className="insight-card-title">
                <img src={FindingsIcon} alt="Findings" /> FINDINGS
              </h4>
              <p className="insight-card__detail-description">{findings}</p>
            </div>
          )}

          {impactData && (
            <div className="insight-card__detail">
              <h4 className="insight-card-title">
                <img src={ImpactIcon} alt="Impact" /> IMPACT
              </h4>
              <p className="insight-card__detail-description">{impactData}</p>
            </div>
          )}

          {narrative && (
            <div className="insight-card__detail single">
              <h4 className="insight-card-title">ANALYSIS</h4>
              <p className="insight-card__detail-description">{highlightCards(narrative, metadata.hashedMappings)}</p>
            </div>
          )}
        </div>

        {summary && evidence && (
          <div className="insight-card__detail evidence">
            <h4 className="insight-card-title"><img src={Evidence} alt="Evidence"/> Evidence</h4>
            <div className="evidence__items">
              {evidence.map((item, index) => (
                <div className="evidence__item" key={index}>
                  <span>{item.name}</span>
                  {' '}
                  <strong>{item.value}</strong>
                </div>
              ))}
            </div>
          </div>
        )}

        {!summary && evidence && (
          <div className="insight-card__detail evidence">
            <h4 className="insight-card-title"><img src={Evidence} alt="Evidence"/> Evidence</h4>
            <div className="evidence__items">
              {evidence.map((item, index) => (
                <div className="evidence__item" key={index}>
                  {item}
                </div>
              ))}
            </div>
          </div>
        )}

        {!summary && insightEvidence && (
          <div className="insight-card__detail investigation-trail">
            <h4 className="insight-card-title"><img src={InvestigationTrail} alt="Investigation Trail"/> EVIDENCE</h4>
            <ul className="insight-card-list">
              {insightEvidence.map((item, index) => (
                <li key={index}>
                  <span className="insight-card-step">{index + 1}</span>
                  <div className="insight-card-analysis">
                    <p>{highlightCards(item, metadata.hashedMappings)}</p>
                  </div>
                </li>
              ))}
            </ul>
          </div>
        )}

        {investigation && false && (
          <div className="insight-card__detail investigation-trail">
            <h4 className="insight-card-title"><img src={InvestigationTrail} alt="Investigation Trail"/> Investigation Trail</h4>
            <ul className="insight-card-list">
              {investigation.map((item, index) => (
                <li key={item.step}>
                  <span className="insight-card-step">{index + 1}</span>
                  <p>{item.step}</p>
                  <p><strong>Result: {item.result}</strong></p>
                  {item.tool && (
                    <p>{item.tool}</p>
                  )}
                  {item.analysis && (
                    <div className="insight-card-analysis">
                      <p><strong>AI REASONING</strong></p>
                      <p>{item.analysis}</p>
                    </div>
                  )}
                </li>
              ))}
            </ul>
          </div>
        )}
      </Modal.Body>
    </Modal>
  );
}

export default InsightWhyModal;
